import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
	createRootRouteWithContext,
	HeadContent,
	Outlet,
} from "@tanstack/react-router";
import { trpc } from "@/utils/trpc";
import "../../index.css";
import { authClient } from "@/lib/auth-client";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createRootRouteWithContext<RouterAppContext>()({
	beforeLoad: async ({ context }: { context: RouterAppContext }) => {

	},
	component: RootComponent,
	notFoundComponent: () => <div>404 Not Found</div>,
});

function RootComponent() {
	return (
		<>
			<HeadContent />
			<Outlet />
			{/* <ReactQueryDevtools position="bottom" buttonPosition="top-right" /> */}
		</>
	);
}
